module.exports = __webpack_public_path__ + "static/media/misis.71514f7b.png";